import { instance } from './_config.js'


const getBillingItems = async (obj) => {
    try {
        const rs = await instance.get(`/billing_items`, obj)
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateBillingItem = async (obj) => {
    try {
        const rs = await instance.post(`billing_items`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const deleteBillingItem = async (id) => {
    try {
        const rs = await instance.delete(`billing_items`, { data: { '_id': id }})
        if (rs.data) {
            return rs.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


export { getBillingItems, updateBillingItem, deleteBillingItem }